import { parseDate } from "@/lib/utils";
import i18n from "@/i18n";
import { Link } from "@heroui/link";
import { CheckIcon } from "@radix-ui/react-icons";
import { ColumnDef } from "@tanstack/react-table";

export type K2PdfPageSelection = {
  id: number;
  client: string | null;
  page_name: string | null;
  tableau_view: string | null;
  tableau_workbook_id: string | null;
  pdf_report_display: boolean | null;
  created_at: string;
};

const tableName = "k2_pdf_page_selection";

export const columns: ColumnDef<K2PdfPageSelection>[] = [
  {
    accessorKey: "id",
    header: () =>
      i18n.t(`${tableName}.columns.id`, {
        ns: "tables",
        defaultValue: "ID",
      }),
  },
  {
    accessorKey: "client",
    header: () =>
      i18n.t(`${tableName}.columns.client`, {
        ns: "tables",
        defaultValue: "Client",
      }),
  },
  {
    accessorKey: "page_name",
    header: () =>
      i18n.t(`${tableName}.columns.page_name`, {
        ns: "tables",
        defaultValue: "Page name",
      }),
  },
  {
    accessorKey: "tableau_view",
    header: () =>
      i18n.t(`${tableName}.columns.tableau_view`, {
        ns: "tables",
        defaultValue: "Tableau view",
      }),
  },
  {
    accessorKey: "tableau_workbook_id",
    header: () =>
      i18n.t(`${tableName}.columns.tableau_workbook_id`, {
        ns: "tables",
        defaultValue: "Tableau workbook ID",
      }),
  },
  {
    accessorKey: "pdf_report_display",
    header: () =>
      i18n.t(`${tableName}.columns.pdf_report_display`, {
        ns: "tables",
        defaultValue: "PDF report display",
      }),
    cell: ({ getValue }) =>
      getValue() && (
        <div className="flex justify-center pr-12">
          <CheckIcon />
        </div>
      ),
  },
  {
    accessorKey: "created_at",
    header: () =>
      i18n.t(`${tableName}.columns.created_at`, {
        ns: "tables",
        defaultValue: "Created at",
      }),
    cell: ({ row }) => {
      return parseDate(row.getValue("created_at"));
    },
  },
  {
    id: "actions",
    header: () => <div className="text-right">Actions</div>,
    cell: ({ row }) => {
      return (
        <div className="flex justify-end">
          <Link
            href={`${window.location.pathname}/${row.getValue("id")}`}
            className="text-xs"
            underline="hover"
          >
            {i18n.t("actions.edit")}
          </Link>
        </div>
      );
    },
  },
];
